import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConstantsService } from '~core/services/constants.service';

@Component({
  selector: 'admin-footer',
  standalone: false,
  templateUrl: './admin-footer.component.html',
  styleUrls: ['./admin-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminFooterComponent {
  protected _constantsService = inject(ConstantsService);

  releaseInfo$ = this._constantsService.getReleaseInfo();
}
